import {
    Button,
    createStyles,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    Tooltip,
    WithStyles,
    withStyles,
} from '@material-ui/core';
import { Edit, UndoOutlined } from '@material-ui/icons';
import { FormikActions } from 'formik';
import _ from 'lodash';
import { inject } from 'mobx-react';
import * as React from 'react';
import { VariableSizeList } from 'react-window';
import ESDialog from 'src/common/ESDialog';
import FullWidthField from 'src/common/FullWidthField';
import { IAffinityCluster, IObservation } from 'src/Definitions';
import { IStores } from 'src/Stores';
import AffinityClusterDialogLogic from './AffinityClusterDialogLogic';

const styles = () => createStyles({});

interface IAffinityClusterDialogProps extends WithStyles<typeof styles> {
    affinityCluster?: IAffinityCluster;
    assessmentId: string;
    close?: () => void;
    getAllAffinityClusters?: (assessmentId: string) => Promise<void>;
    getObservationIcon?: (observation: IObservation) => React.ReactNode;
    isLoading?: boolean;
    isOpen?: boolean;
    saveAffinityCluster?: (affinityCluster: IAffinityCluster) => Promise<void>;
    undo?: (observation: IObservation) => void;
}

class AffinityClusterDialog extends React.Component<IAffinityClusterDialogProps> {
    private _logic: AffinityClusterDialogLogic = new AffinityClusterDialogLogic();
    public state = {
        openEditDialog: false,
    };

    public save = (values: IAffinityCluster, formikBag: FormikActions<IAffinityCluster>) => {
        this.props.saveAffinityCluster!({ ...values, observations: undefined }).finally(() => {
            this.props.getAllAffinityClusters!(this.props.assessmentId).then(() => {
                formikBag.setSubmitting(false);
            });
        });
    };

    public undo = (observation: IObservation) => () => {
        this._logic.undo(this.props.affinityCluster!, observation);

        this.props.undo!(observation);

        this.setState({});
    };

    private editName = () => {
        this.setState({ openEditDialog: true });
    };

    private close = () => {
        this.setState({ openEditDialog: false });
    };

    private editDialog() {
        return (
            <ESDialog
                open={this.state.openEditDialog}
                save={this.save}
                title={'Edit Affinity Cluster Label'}
                initialValues={{ ...this.props.affinityCluster } as IAffinityCluster}
                close={this.close}
                maxWidth="sm"
            >
                {() => (
                    <Grid container direction="row" style={{ paddingTop: '10px' }}>
                        <Grid item>
                            <FullWidthField
                                name="name"
                                label="Label"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                )}
            </ESDialog>
        );
    }

    public render() {
        const getItemSize = () => 75;
        const { affinityCluster, isOpen, close } = this.props;
        return (
            <>
                {affinityCluster ? (
                    <>
                        {this.editDialog()}
                        <Dialog open={isOpen || true} maxWidth="lg" onClose={close}>
                            <DialogTitle>
                                {affinityCluster ? affinityCluster!.name : ''}
                                <Edit onClick={this.editName} style={{ cursor: 'pointer' }} />
                            </DialogTitle>
                            <DialogContent>
                                <VariableSizeList
                                    height={400}
                                    width={800}
                                    itemCount={affinityCluster!.observations!.length}
                                    itemData={affinityCluster!.observations}
                                    itemSize={getItemSize}
                                >
                                    {({ data, index, style }) => (
                                        <div style={style}>
                                            <Grid container direction="row" spacing={8}>
                                                <Grid item>
                                                    <Grid container direction="column">
                                                        <Grid item>
                                                            <div>
                                                                {this.props.getObservationIcon!(
                                                                    data[index]
                                                                )}
                                                            </div>
                                                        </Grid>
                                                        <Grid item>
                                                            <div>
                                                                <Tooltip title="Undo">
                                                                    <UndoOutlined
                                                                        onClick={this.undo!(
                                                                            data[index]
                                                                        )}
                                                                    />
                                                                </Tooltip>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <div>
                                                        <strong>
                                                            {data[index].observer.name}:{' '}
                                                        </strong>
                                                        <br />
                                                        <div
                                                            style={{
                                                                height: '78px',
                                                                overflowY: 'auto',
                                                                width: '725px',
                                                            }}
                                                        >
                                                            {data[index].observationDescription}
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}
                                </VariableSizeList>
                            </DialogContent>
                            <Button onClick={close} data-cy="close">
                                Close
                            </Button>
                        </Dialog>
                    </>
                ) : (
                    <></>
                )}
            </>
        );
    }
}

const InjectedAffinityClusterDialog = inject<
    IStores,
    IAffinityClusterDialogProps,
    Partial<IAffinityClusterDialogProps>,
    any
>((stores: IStores) => ({
    close: stores.affinityClusters.closeDialog,
    getAllAffinityClusters: stores.affinityClusters.getAllAffinityClusters,
    getObservationIcon: stores.observations.getObservationIcon,
    isLoading: stores.affinityClusters.isLoading,
    isOpen: stores.affinityClusters.isModalOpen,
    saveAffinityCluster: stores.affinityClusters.saveAffinityCluster,
}))(withStyles(styles)(AffinityClusterDialog));

export default InjectedAffinityClusterDialog;



// WEBPACK FOOTER //
// ./src/affinityClusters/AffinityClusterDialog.tsx